(() => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const loader = document.querySelector("[data-ba-loader]");
  if (loader) {
    const seen = (() => {
      try {
        return sessionStorage.getItem("ba:seen");
      } catch (e) {
        return null;
      }
    })();
    if (seen || reduce || window.Shopify?.designMode) {
      loader.remove();
      document.documentElement.classList.add("ba-ready");
    } else {
      document.documentElement.classList.add("ba-loading");
      const count = loader.querySelector("[data-ba-loader-count]");
      const bar = loader.querySelector("[data-ba-loader-bar]");
      const start = performance.now();
      const dur = 1600;
      const tick = (now) => {
        const t = Math.min(1, (now - start) / dur);
        const eased = 1 - Math.pow(1 - t, 3);
        const n = Math.round(eased * 100);
        if (count) count.textContent = String(n).padStart(2, "0");
        if (bar) bar.style.transform = `scaleX(${eased})`;
        if (t < 1) requestAnimationFrame(tick);
        else {
          loader.classList.add("is-done");
          document.documentElement.classList.remove("ba-loading");
          document.documentElement.classList.add("ba-ready");
          try {
            sessionStorage.setItem("ba:seen", "1");
          } catch (e) {}
          setTimeout(() => loader.remove(), 800);
        }
      };
      requestAnimationFrame(tick);
    }
  } else {
    document.documentElement.classList.add("ba-ready");
  }

  const onScroll = () => {
    document.documentElement.classList.toggle("ba-scrolled", window.scrollY > 12);
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  document.querySelectorAll("[data-ba-line]").forEach((line) => {
    const text = line.textContent || "";
    line.textContent = "";
    [...text].forEach((ch, i) => {
      const span = document.createElement("span");
      span.className = "ba-ch";
      span.style.setProperty("--i", String(i));
      span.textContent = ch === " " ? "\u00a0" : ch;
      line.appendChild(span);
    });
  });

  const reveal = document.querySelectorAll(
    ".ba-hero__line, .ba-story, .card-wrapper, .ba-sms, .ba-hero__lede, .ba-hero__actions, .ba-hero__copy, .collection__title, .ba-foot__mark"
  );
  if (!reduce && "IntersectionObserver" in window) {
    reveal.forEach((el) => el.classList.add("ba-wait"));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ba-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    reveal.forEach((el) => io.observe(el));
  }

  const canvas = document.querySelector("[data-ba-dust]");
  const hero = document.querySelector("[data-ba-hero]");
  if (canvas && !reduce) {
    const ctx = canvas.getContext("2d");
    const dots = Array.from({ length: 56 }, () => ({
      x: Math.random(),
      y: Math.random(),
      r: Math.random() * 1.8 + 0.3,
      s: Math.random() * 0.28 + 0.04,
      a: Math.random() * 0.4 + 0.06,
    }));
    const resize = () => {
      canvas.width = canvas.clientWidth * devicePixelRatio;
      canvas.height = canvas.clientHeight * devicePixelRatio;
      ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);
    let mx = 0.5;
    let my = 0.5;
    hero?.addEventListener("pointermove", (e) => {
      const b = canvas.getBoundingClientRect();
      mx = (e.clientX - b.left) / b.width;
      my = (e.clientY - b.top) / b.height;
    });
    const draw = () => {
      const w = canvas.clientWidth;
      const h = canvas.clientHeight;
      ctx.clearRect(0, 0, w, h);
      dots.forEach((d) => {
        d.y -= d.s / 130;
        if (d.y < 0) d.y = 1;
        ctx.beginPath();
        ctx.fillStyle = `rgba(226,74,27,${d.a})`;
        ctx.arc(d.x * w + (mx - 0.5) * 28, d.y * h + (my - 0.5) * 20, d.r, 0, Math.PI * 2);
        ctx.fill();
      });
      requestAnimationFrame(draw);
    };
    draw();
  }

  const hat = document.querySelector("[data-ba-hat]");
  if (hat && hero && !reduce && window.matchMedia("(pointer: fine)").matches) {
    hero.addEventListener("pointermove", (e) => {
      const b = hero.getBoundingClientRect();
      const x = ((e.clientX - b.left) / b.width - 0.5) * 14;
      const y = ((e.clientY - b.top) / b.height - 0.5) * 10;
      hat.style.transform = `translate3d(${x}px, ${y}px, 0) rotateX(${-y * 0.4}deg) rotateY(${x * 0.4}deg)`;
    });
  }

  const cursor = document.querySelector("[data-ba-cursor]");
  if (cursor && !reduce && window.matchMedia("(pointer: fine)").matches) {
    document.documentElement.classList.add("ba-cursor-on");
    let x = 0;
    let y = 0;
    let cx = 0;
    let cy = 0;
    window.addEventListener(
      "pointermove",
      (e) => {
        x = e.clientX;
        y = e.clientY;
        cursor.classList.toggle("is-hot", Boolean(e.target.closest("a, button, summary")));
      },
      { passive: true }
    );
    const follow = () => {
      cx += (x - cx) * 0.22;
      cy += (y - cy) * 0.22;
      cursor.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
      requestAnimationFrame(follow);
    };
    follow();
  }

  document.querySelectorAll("[data-ba-magnet]").forEach((btn) => {
    if (reduce || !window.matchMedia("(pointer: fine)").matches) return;
    btn.addEventListener("pointermove", (e) => {
      const b = btn.getBoundingClientRect();
      const dx = e.clientX - (b.left + b.width / 2);
      const dy = e.clientY - (b.top + b.height / 2);
      btn.style.transform = `translate(${dx * 0.12}px, ${dy * 0.18}px)`;
    });
    btn.addEventListener("pointerleave", () => {
      btn.style.transform = "";
    });
  });

  document.querySelectorAll(".collection .grid, .product-grid").forEach((grid) => {
    grid.querySelectorAll(".grid__item").forEach((item, i) => {
      if (item.querySelector(".ba-idx")) return;
      const tag = document.createElement("span");
      tag.className = "ba-idx";
      tag.textContent = String(i + 1).padStart(3, "0");
      item.prepend(tag);
    });
  });

  document.querySelectorAll("[data-ba-zoom-set]").forEach((root) => {
    const dataEl = root.querySelector("[data-ba-zoom-data]");
    const dialog = root.querySelector("[data-ba-zoom]");
    if (!dataEl || !dialog) return;

    let shots = [];
    try {
      shots = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!shots.length) return;

    const img = dialog.querySelector("[data-ba-zoom-img]");
    const count = dialog.querySelector("[data-ba-zoom-count]");
    const prevBtn = dialog.querySelector("[data-ba-zoom-prev]");
    const nextBtn = dialog.querySelector("[data-ba-zoom-next]");
    const many = shots.length > 1;
    let index = 0;

    const pad = (n) => String(n).padStart(2, "0");

    const show = (i) => {
      index = (i + shots.length) % shots.length;
      const shot = shots[index];
      img.src = shot.src;
      img.alt = shot.alt || "";
      if (count) count.textContent = `${pad(index + 1)} / ${pad(shots.length)}`;
      const neighbor = shots[(index + 1) % shots.length];
      if (neighbor && neighbor.src !== shot.src) {
        const preload = new Image();
        preload.src = neighbor.src;
      }
    };

    if (dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }

    const open = (i) => {
      show(i);
      if (typeof dialog.showModal === "function") dialog.showModal();
      else dialog.setAttribute("open", "");
    };

    const close = () => {
      if (typeof dialog.close === "function" && dialog.open) dialog.close();
      else dialog.removeAttribute("open");
    };

    root.querySelectorAll("[data-ba-zoom-open]").forEach((btn) => {
      btn.addEventListener("click", () => open(Number(btn.getAttribute("data-ba-zoom-open")) || 0));
    });

    dialog.querySelector("[data-ba-zoom-close]")?.addEventListener("click", close);
    prevBtn?.addEventListener("click", () => show(index - 1));
    nextBtn?.addEventListener("click", () => show(index + 1));
    if (prevBtn) prevBtn.hidden = !many;
    if (nextBtn) nextBtn.hidden = !many;

    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) close();
    });

    dialog.addEventListener("keydown", (e) => {
      if (!dialog.open) return;
      if (e.key === "ArrowLeft") show(index - 1);
      if (e.key === "ArrowRight") show(index + 1);
    });

    let startX = 0;
    dialog.addEventListener(
      "touchstart",
      (e) => {
        startX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );
    dialog.addEventListener(
      "touchend",
      (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        if (dx > 56) show(index - 1);
        else if (dx < -56) show(index + 1);
      },
      { passive: true }
    );
  });

  document.querySelectorAll("[data-ba-turn]").forEach((video) => {
    video.muted = true;
    if (reduce) {
      video.removeAttribute("autoplay");
      video.pause();
      return;
    }
    const play = () => {
      video.play().catch(() => {});
    };
    play();
    video.addEventListener("click", play);
  });

  document.querySelectorAll("[data-ba-add-items]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      if (btn.getAttribute("aria-disabled") === "true") return;
      const ids = (btn.getAttribute("data-ba-add-items") || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);
      if (!ids.length) return;

      const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      const spinner = btn.querySelector(".loading__spinner");
      btn.setAttribute("aria-disabled", "true");
      btn.classList.add("loading");
      spinner?.classList.remove("hidden");

      const formData = new FormData();
      ids.forEach((id, i) => {
        formData.append(`items[${i}][id]`, id);
        formData.append(`items[${i}][quantity]`, "1");
      });
      if (cart) {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      config.body = formData;

      try {
        const response = await fetch(window.routes.cart_add_url, config).then((res) => res.json());
        if (response.status) return;
        if (cart) cart.renderContents(response);
        else window.location = window.routes.cart_url;
      } catch (err) {
        console.error(err);
      } finally {
        btn.classList.remove("loading");
        btn.removeAttribute("aria-disabled");
        spinner?.classList.add("hidden");
      }
    });
  });
})();
